import { ShippingAccountContract } from "../../domain/contracts/shipping_account_contract";
import { shippingAccountEntity } from "../../domain/entities/shipping_account"
import http from "../../../../plugins/http-common"
// import i18n from "../../../../i18n";

export const HttpShippingAccountsRepository = {
  ...ShippingAccountContract,
  model: shippingAccountEntity,

  async index() {
    const res = await http.get('shipping_accounts');

    return res;
  },
};